$shm_hitalama_map_widget_float_prompt $shm_hitalama_map_widget_float_form_custom
	head /
		^
		<= Copy $shm_button_copy
			theme \$mol_theme_base
			title \Скопировать промпт
			text <= prompt \
	buttons /
		<= Clear
